// extracted by mini-css-extract-plugin
module.exports = {"resultsTitle":"Search_resultsTitle__2x30i","results":"Search_results__2tJqS","empty":"Search_empty__3HVTs"};